export const ASSISTANT_CHATBOT_VISIBILITY_EVENT =
  'assistant-chatbot-visibility-change';

const ASSISTANT_CHATBOT_HIDDEN_KEY = 'assistantChatbotHidden';

export function getAssistantChatbotHidden() {
  if (typeof window === 'undefined') return false;

  try {
    return localStorage.getItem(ASSISTANT_CHATBOT_HIDDEN_KEY) === 'true';
  } catch {
    return false;
  }
}

export function setAssistantChatbotHidden(value) {
  if (typeof window === 'undefined') return;

  try {
    localStorage.setItem(
      ASSISTANT_CHATBOT_HIDDEN_KEY,
      value ? 'true' : 'false'
    );
  } catch {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(ASSISTANT_CHATBOT_VISIBILITY_EVENT, {
      detail: { hidden: value },
    })
  );
}
